var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchIconSecondary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 4,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 22.5C20.2614 22.5 22.5 20.2614 22.5 17.5C22.5 14.7386 20.2614 12.5 17.5 12.5C14.7386 12.5 12.5 14.7386 12.5 17.5C12.5 20.2614 14.7386 22.5 17.5 22.5ZM17.5 24C21.0899 24 24 21.0899 24 17.5C24 13.9101 21.0899 11 17.5 11C13.9101 11 11 13.9101 11 17.5C11 21.0899 13.9101 24 17.5 24Z",
    fill: "#04AAF0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4697 21.4697C21.7626 21.1768 22.2374 21.1768 22.5303 21.4697L27.5303 26.4697C27.8232 26.7626 27.8232 27.2374 27.5303 27.5303C27.2374 27.8232 26.7626 27.8232 26.4697 27.5303L21.4697 22.5303C21.1768 22.2374 21.1768 21.7626 21.4697 21.4697Z",
    fill: "#04AAF0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIconSecondary);
export default __webpack_public_path__ + "static/media/SearchIconSecondary.eb2341c61f9bd68d28ae8bc17b118dcf.svg";
export { ForwardRef as ReactComponent };